import { render, staticRenderFns } from "./tradeLeadDetail.vue?vue&type=template&id=4b46f28b&scoped=true&"
import script from "./tradeLeadDetail.vue?vue&type=script&lang=js&"
export * from "./tradeLeadDetail.vue?vue&type=script&lang=js&"
import style0 from "./tradeLeadDetail.vue?vue&type=style&index=0&id=4b46f28b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b46f28b",
  null
  
)

export default component.exports